import * as space from './space'
import * as entry from './entry'
import * as asset from './asset'
import * as contentType from './content-type'

export default {
  space,
  entry,
  asset,
  contentType
}



// WEBPACK FOOTER //
// ./entities/index.js